<template>
  <div class="paindexouter">
    <div class="page-index" v-show="colorindex != 99 && colorindex != 100">
      <!--    <video class="videoone" autoplay muted loop>-->
      <!--      <source src="../assets/image/he.mp4" type="video/mp4">-->
      <!--    </video>-->
<!--      <img class="videoone" src="../assets/1920915.png" alt="">-->

      <!--    中间内容-->
      <div class="wmiddle">
        <div class="flex-cc">
          <img class="mlogo1" src="../assets/logo.png" alt="">
          <div class="mlogo2">
            <div class="mlp1">网络空间内生安全知识平台</div>
            <div class="mlp2">KNOWLEDGE SYSTEM OF CYBERSPACE ENDOGENOUS SAFETY&SECURITY</div>
          </div>
        </div>
        <div class="w100 flex-cc z999">
          <el-input class="sinput1" v-model="sform.input" placeholder="搜索内容"></el-input>
        </div>
        <div class="w100 flex-cc z999">
          <el-form :inline="true" :model="sform" class="demo-form-inline sformin">
            <el-form-item label="文件类型" class="w200 wnew200">
              <!--            <el-select class="triangle-select" v-model="sform.region" placeholder="活动区域">-->
              <!--              <el-option label="区域一" value="shanghai"></el-option>-->
              <!--              <el-option label="区域二" value="beijing"></el-option>-->
              <!--            </el-select>-->

              <el-cascader
                  v-model="sform.categoryId"
                  :options="neilist"
                  ref="myCascader"
                  :props="topprops"
                  @change="handleChange"></el-cascader>
            </el-form-item>
            <el-form-item label="上传时间" class="w270 wnew270">
              <el-date-picker
                  v-model="sform.time"
                  popper-append-to-body
                  type="daterange"
                  ref="datePicker"
                  :placement.sync="pickerPlacement"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="发布人" class="w200 wnew200">
              <el-input v-model="sform.user" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item>
              <div class="flex-hl">
                <div @click="subsear" class="searbtn1 ignore cur"><i class="el-icon-search"></i></div>
                <div @click="resetsear" class="searbtn2 ignore cur">重置</div>
              </div>

            </el-form-item>
          </el-form>
        </div>

<!--qqq-->
        <div class="qiuout">
          <div class="main">
            <div class="animation-container">
              <div
                  v-for="(circle, index) in circles"
                  :key="index"
                  @mouseenter="stopAnimation"
                  @mouseleave="startAnimation"
                  @click="topage(circle)"
                  class="orbiting-circle flex-sc"
                  :style="{
            width: circle.currentSize + 'px',
            height: circle.currentSize + 'px',
            opacity: circle.currentOpacity,
            '--posX': circle.posX + 'px',
            '--posY': circle.posY + 'px',
            zIndex: circle.zIndex
          }"
              >
                <img class="cqimg" :src="circle.url" alt="">
              <span>  {{ circle.name }}</span>
              </div>
            </div>
<!--            <div class="total">-->
<!--              <div class="cicle0 colorb flex-sc" @click="topage('争鸣论坛','/forum')" @mouseenter="qiunum = 0"-->
<!--                   @mouseleave="qiunum = 99" :class="[qiunum === 0?'qiux':'qiuno']">-->
<!--                <img class="cqimg" src="../assets/luntan.png" alt="">-->
<!--                <div class="cq-t2">争鸣论坛</div>-->
<!--              </div>-->
<!--              <div class="cicle1 colorb flex-sc" @click="topage('1988863547785265154','/knowledge')" @mouseenter="qiunum = 1"-->
<!--                   @mouseleave="qiunum = 99" :class="[qiunum == 1?'qiux':'qiuno']">-->
<!--                <img class="cqimg" src="../assets/lianghuapinggu.png" alt="">-->
<!--                <div class="cq-t2">量化评估</div>-->
<!--              </div>-->
<!--              <div class="cicle2 colorb flex-sc" @click="topage('1988863558229082113','/knowledge')" @mouseenter="qiunum = 2"-->
<!--                   @mouseleave="qiunum = 99" :class="[qiunum == 2?'qiux':'qiuno']">-->
<!--                <img class="cqimg" src="../assets/qianyandongtai.png" alt="">-->
<!--                <div class="cq-t2">前沿动态</div>-->
<!--              </div>-->
<!--              <div class="cicle3 colorb flex-sc" @click="topage('1988863566936457218','/knowledge')" @mouseenter="qiunum = 3"-->
<!--                   @mouseleave="qiunum = 99" :class="[qiunum == 3?'qiux':'qiuno']">-->
<!--                <img class="cqimg" src="../assets/jishushengtai.png" alt="">-->
<!--                <div class="cq-t2">技术生态</div>-->
<!--              </div>-->
<!--              <div class="cicle4 colorb flex-sc" @click="topage('1988863576289755137','/knowledge')" @mouseenter="qiunum = 4"-->
<!--                   @mouseleave="qiunum = 99" :class="[qiunum == 4?'qiux':'qiuno']">-->
<!--                <img class="cqimg" src="../assets/gongchengyingyong.png" alt="">-->
<!--                <div class="cq-t2">工程应用</div>-->
<!--              </div>-->
<!--              <div class="cicle5 colorb flex-sc" @click="topage('1988863589136908289','/knowledge')" @mouseenter="qiunum = 5"-->
<!--                   @mouseleave="qiunum = 99" :class="[qiunum == 5?'qiux':'qiuno']">-->
<!--                <img class="cqimg" src="../assets/zhanlueyanjiu.png" alt="">-->
<!--                <div class="cq-t2">战略研究</div>-->
<!--              </div>-->
<!--              <div class="cicle6 colorb flex-sc" @click="topage('1988863599006105602','/knowledge')" @mouseenter="qiunum = 6"-->
<!--                   @mouseleave="qiunum = 99" :class="[qiunum == 6?'qiux':'qiuno']">-->
<!--                <img class="cqimg" src="../assets/jichulilun.png" alt="">-->
<!--                <div class="cq-t2">基础理论</div>-->
<!--              </div>-->
<!--              <div class="cicle7 colorb flex-sc" @click="topage('1988863608267128833','/knowledge')" @mouseenter="qiunum = 7"-->
<!--                   @mouseleave="qiunum = 99" :class="[qiunum == 7?'qiux':'qiuno']">-->
<!--                <img class="cqimg" src="../assets/zhishichanquan.png" alt="">-->
<!--                <div class="cq-t2">知识产权</div>-->
<!--              </div>-->
<!--              <div class="cicle8 colorb flex-sc" @click="topage('1988863618597699585','/knowledge')" @mouseenter="qiunum = 8"-->
<!--                   @mouseleave="qiunum = 99" :class="[qiunum == 8?'qiux':'qiuno']">-->
<!--                <img class="cqimg" src="../assets/kechengxuexi.png" alt="">-->
<!--                <div class="cq-t2">课程学习</div>-->
<!--              </div>-->
<!--              <div class="cicle9 colorb flex-sc" @click="topage('1988863633227431937','/knowledge')" @mouseenter="qiunum = 9"-->
<!--                   @mouseleave="qiunum = 99" :class="[qiunum == 9?'qiux':'qiuno']">-->
<!--                <img class="cqimg" src="../assets/AI.png" alt="">-->
<!--                <div class="cq-t2">智能助理</div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
<!--    需要再放开-->
<!--    <div class="bottomd flex-cc">-->
<!--      <span>Copyright ◎ 2026 紫金山实验室,All Rights Reserved.</span>-->
<!--      <span class="shus"></span>-->
<!--      <img src="../assets/guohui.png" class="jinghui" alt="">-->
<!--      <span>苏CP备14016373号-4</span>-->
<!--    </div>-->

    <el-dialog
        title="找回密码"
        class="tanpass1"
        append-to-body
        :show-close="false"
        :visible.sync="recoverlook"
        width="40%">
      <el-form :model="recoverform" :rules="rules" ref="recoverform" label-width="100px"
               class="demo-ruleForm loginform">
        <el-form-item label="邮箱" prop="email">
          <el-input placeholder="请输入" v-model="recoverform.email"></el-input>
        </el-form-item>
        <el-form-item class="yaninput" label="邮箱验证码" prop="code">
          <el-input placeholder="请输入" v-model="recoverform.code"></el-input>
          <div @click="getcodet" class="cgetm">{{ msgt }}</div>
        </el-form-item>
        <el-form-item label="设置新密码" prop="password">
          <!--              <el-input v-model="recoverform.name" show-password></el-input>-->
          <el-input placeholder="请输入" v-model="recoverform.password"></el-input>
        </el-form-item>
        <el-form-item label="重复新密码" prop="pwd">
          <!--              <el-input v-model="recoverform.name" show-password></el-input>-->
          <el-input placeholder="请输入" v-model="recoverform.pwd"></el-input>
        </el-form-item>
        <el-form-item>
          <div class="w100 flex-cc">
            <div @click="closerecover" class="quxiaohui mr20">取消</div>
            <div @click="submitFormcover('recoverform')" class="querenlan">确定</div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>


<script>
import $ from 'jquery'

export default {
  data() {
    // 邮箱正则表达式
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // 密码强度验证函数
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      }

      // 定义字符类型
      const hasLower = /[a-z]/.test(value) // 小写字母
      const hasUpper = /[A-Z]/.test(value) // 大写字母
      const hasNumber = /\d/.test(value)   // 数字
      const hasSpecial = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value) // 特殊字符

      // 统计字符类型数量
      const typeCount = [hasLower, hasUpper, hasNumber, hasSpecial].filter(Boolean).length

      if (typeCount < 3) {
        return callback(new Error('密码需包含至少三种字符类型（数字、大小写字母、特殊字符）'))
      }

      // 额外长度要求
      if (value.length < 8) {
        return callback(new Error('密码长度至少8位'))
      }
      if (value.length > 20) {
        return callback(new Error('密码长度不能超过20位'))
      }

      callback()
    }
    // 密码强度验证函数
    const valtwo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      }

      if (this.locolnum == 1) {//忘记密码
        if (value != this.loginform.password) {
          return callback(new Error('两次密码输入不一致'))
        }
      }
      if (this.recoverlook) {//找回密码
        if (value != this.recoverform.password) {
          return callback(new Error('两次密码输入不一致'))
        }
      }
      callback()
    }
    // 密码强度验证函数
    const valthr = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      }

        if (value != this.editform.password) {
          return callback(new Error('两次密码输入不一致'))
        }
      callback()
    }
    return {
      circles: [],
      animationRunning: true,
      rotationSpeed: 25,
      baseRadiusX: 360,  // 基础X轴半径
      baseRadiusY: 150,  // 基础Y轴半径
      minSize:180,
      maxSize:240,
      direction: 1,
      animationFrameId: null,
      imgurl:[{url:require("../assets/lianghuapinggu.png")},{url:require("../assets/qianyandongtai.png")},{url:require("../assets/jishushengtai.png")},{url:require("../assets/gongchengyingyong.png")},{url:require("../assets/zhanlueyanjiu.png")},{url:require("../assets/jichulilun.png")},{url:require("../assets/zhishichanquan.png")},{url:require("../assets/kechengxuexi.png")},{url:require("../assets/kechengxuexi.png")},{url:require("../assets/kechengxuexi.png")},{url:require("../assets/AI.png")},{url:require("../assets/luntan.png")},],
      colors: [
        'linear-gradient(135deg, #ff9a9e, #fad0c4)',
        'linear-gradient(135deg, #a1c4fd, #c2e9fb)',
        'linear-gradient(135deg, #ffecd2, #fcb69f)',
        'linear-gradient(135deg, #84fab0, #8fd3f4)',
        'linear-gradient(135deg, #d4fc79, #96e6a1)',
        'linear-gradient(135deg, #a6c0fe, #f68084)',
        'linear-gradient(135deg, #fccb90, #d57eeb)'
      ],
      texts: ['Vue', 'CSS3', '动画', '旋转', '渐变', '效果', '前端', '开发', 'JS', 'HTML'],
      url: '',
      locolnum: 0,//0立即登录
      pickerPlacement: 'bottom-start',
      sform: {
        input: '',
        time: '',
        user: '',
        categoryId: '',
      },
      // 消息
      xform: {
        input: '',
        time: '',
      },
      msg: '获取',
      seconds: 60,
      clock: '',
      isSend: false,
      msgt: '获取',
      secondst: 60,
      clockt: '',
      isSendt: false,
      mynum: 0,//0邀请的1回复我的
      lunnum: 0,//0发布的1回复的
      xtopnum: 0,//顶部切换0个人信息1修改密码2我的论坛3消息，
      titlew: ' 中外专家为构建网络安全免疫系统建言献策 ',
      recoverlook: false,//找回密码
      imageUrl: '',//头像
      windowWidth:0,
      userinfo:JSON.parse(localStorage.getItem('muiuserinfo') || '{}')?.userInfo || null,
      datayaolist:[],
      // 登录
      loginform: {
        nickname: 'a1',
        name: '',
        email: '',
        password: '123456qaz+',
        pwd: '',
        code: '',
      },
      // 找回密码
      recoverform: {
        code: '',
        email: '',
        password: '',
        pwd: '',
      },
      // 个人信息
      infoform: {
        name: '',
        role: '',
        dept: '',
      },
      // 修改密码
      editform: {
        passwordy: '',
        password: '',
        passthr: '',
      },
      pageObj: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      pageObjh: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      datahuimylist:[],//回复我的
      datalist:[],
      // 我发布的
      pageObjlone: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      // 我回复的
      datalisttwo:[],
      pageObjltwo: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      rules: {
        nickname: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        passwordy: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        name: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        pwd: [
          {required: true, message: '请输入', trigger: ['blur', 'change']},
          {validator: valtwo, trigger: ['blur', 'change']}
        ],
        passthr: [
          {required: true, message: '请输入', trigger: ['blur', 'change']},
          {validator: valthr, trigger: ['blur', 'change']}
        ],
        password: [
          {required: true, message: '请输入', trigger: ['blur', 'change']},
          {validator: validatePassword, trigger: ['blur', 'change']}
        ],
        email: [
          {required: true, message: '请输入', trigger: 'blur'},
          {
            pattern: emailPattern,
            message: '请输入正确的邮箱格式',
            trigger: 'blur'
          }
        ],
      },
      rulesrecover: {
        name: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        email: [
          {required: true, message: '请输入邮箱地址', trigger: 'blur'},
          {
            pattern: emailPattern,
            message: '请输入正确的邮箱格式',
            trigger: 'blur'
          }
        ],
      },
      qiunum: '',
      ipAddress: '',
      topprops:{
        label:'name',
        children:'children',
        value:'id',
        // emitPath:false
      },
      neilist:[],//顶部二级分类
      neilist2:[],//顶部二级分类-处理过的，加上了智能助理和争鸣论坛
      noreadinfo:'',//未读信息
      datatest:[{name:'11',id:1},{name:'22',id:2},],
    }
  },
  props: {
    colorindex: [String, Object, Array, Number],
    // infonum: [String, Object, Array, Number],
  },
  watch: {
    colorindex: function (val) {
      // console.log('val', val)
    },
    $route(to, from) {
      // if (this.$route.query.value) {
      //     let value = String(this.$route.query.value)
      //     this.to(value);
      // }
    }
  },

  beforeDestroy() {
    this.stopAnimation();
    document.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener('resize', _.debounce(this.updateWindowWidth, 100));
  },
  created() {
    this.getData()
    // if (this.$route.query.value) {
    //     this.to(this.$route.query.value)
    // }
  },
  // 111
  mounted() {
    this.updateWindowWidth();
    window.addEventListener('resize', this.updateWindowWidth);
    // console.log(this.$route.query,this.colorindex)
    // 获取ip地址所属区域
    // this.getIpAddress()
    // 本地存储如果有,说明是点击上面的进来的,并且要根据点击的去刷新指定的框
    if(localStorage.getItem('infonum')){
      let num = Number(localStorage.getItem('infonum'))
      this.xtopnum = num;
      if(num == 2){//我发布的
        this.getlunlist();
      }else if(num == 3){
        this.getmsglist()
      }
    }
    // 回显个人信息
    const loginData = JSON.parse(localStorage.getItem('muiuserinfo') || '{}')
    this.userinfo = loginData?.userInfo || null
    if (this.userinfo) {
      this.infoform = {
        name: this.userinfo.name || '',
        role: this.userinfo.role || '',
        dept: this.userinfo.dept || '',
      }
      if (this.userinfo.photo) {
        this.imageUrl = this.userinfo.photo
      }
    }
    // 个人信息未读和已读（登录后才调用）
    if (this.userinfo) {
      this.getnoread();
    }
    // 点击日期选择器之外关闭选项
    document.addEventListener('click', this.handleClickOutside);
    this.getneilist();//获取顶部分类-权限控制的
    this.getneilistall();//获取顶部分类-所有的
    // $('.qiuout').children('.qiuone').hover(function () {
    //   $(this).addClass('qiuhot').siblings('.qiuone').removeClass('qiuhot');
    // });
  },
  // 22
  methods: {
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
      if(window.innerWidth < 1441){
        this.minSize = 170;
        this.maxSize = 200;
        this.baseRadiusX = 300;
        this.baseRadiusY = 100;
      }
      console.log('window.innerWidth',window.innerWidth)
    },
    // 未读数量
    getnoread(){
      // 检查是否有用户信息，没有则不调用
      let userinfo = JSON.parse(localStorage.getItem('muiuserinfo') || '{}')?.userInfo || null
      if (!userinfo) {
        return;
      }
      let data={}
      this.$http({
        url: "msg/count",
        method: "POST",
        data: data
      }).then(res => {
        this.noreadinfo = res.data;
      }).catch(err => {
        // 如果调用失败（如未登录），忽略错误
        console.log('获取未读消息失败', err);
      });
    },
    subyaow(){
      this.pageObj = {
        pageSize: 10,
        currentPage: 1
      }
      this.getmsglist();
    },
    // 重置邀请我的
    resetyao(){
      this.xform = Object.assign(this.xform, this.$options.data().xform)
      this.pageObj = {
        pageSize: 10,
        currentPage: 1
      }
      this.getmsglist();
    },
    // 跳转文章详情
    toarti(val){
      let data={
        msgId:val.id
      }
      this.$http({
        url: "msg/read",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.$emit('cgetnoread','1');
        localStorage.removeItem('colorindex');
        this.$router.push({
          path: '/knowledge',
          query:{
            parentid:val.article.categoryPid,//父级id
            id: val.article.categoryId,//分类id
            artiid:val.article.id,
          }
        })
      });
    },
    // 跳转帖子详情
    todetail(val){
      localStorage.removeItem('colorindex');
      this.$router.push({
        path: '/forum',
        query:{
          tieid:val.id
        }
      })
    },
    // 跳转评价
    toping(val,num){
      if(num == 1){
        let data={
          commentId:val.id
        }
        this.$http({
          url: "comment/read",
          method: "POST",
          data: this.$form(data)
        }).then(res => {
          localStorage.removeItem('colorindex');
          this.$emit('cgetnoread','1');
          this.$router.push({
            path: '/forum',
            query:{
              tieid:val.post.id,
              pingid:val.id,
            }
          })
        });
      }else{
        localStorage.removeItem('colorindex');
        this.$router.push({
          path: '/forum',
          query:{
            tieid:val.post.id,
            pingid:val.id,
          }
        })
      }

    },
    resetpage(val){
      // this.mynum = 0;
      if(val){//有值是顶部切换
        this.lunnum = 0;
        this.mynum = 0;
      }
      // this.datalist = [];
      // this.datalisttwo = [];
      this.pageObjltwo = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.pageObjlone = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.pageObj = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.pageObjh = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    },
    // 222
    getneilist() {
      // let data = {
      //   auth:1
      // }
      let data = {}
      // 未登录状态下只有登录和首页可以点击
      if (!this.userinfo) {
        data.auth = 0
      }else{
        data.auth = 1
      }
      this.$http({
        url:'category/tree',
        method:'post',
        data:this.$form(data)
      }).then((res)=>{
        let neilist = JSON.parse(JSON.stringify(res.data));
        if(neilist){
          neilist.forEach((item,index)=>{
            if(!item.children){
              item.disabled = true;
            }
          })
          this.neilist = neilist;
        }
        console.log('this.neilist',this.neilist)
        this.loading = false;
      }).catch(err=>{
        this.loading = false;
      })
    },
    // 222
    getneilistall() {
      let data = {}
      this.$http({
        url:'category/tree',
        method:'post',
        data:this.$form(data)
      }).then((res)=>{
        if(res.data){
          let neilist2 = JSON.parse(JSON.stringify(res.data));
          neilist2 = neilist2.concat([{name:'智能助理',id:'98'},{name:'争鸣论坛',id:'99'}]);
          console.log('this.neilist2',this.neilist2)
          this.neilist2 = neilist2;
          this.initCircles(this.neilist2.length);
          this.startAnimation();
        }else{
          this.neilist2 = [{name:'智能助理',id:'98'},{name:'争鸣论坛',id:'99'}];
          this.initCircles(this.neilist2.length);
          this.startAnimation();
        }

        this.loading = false;
      }).catch(err=>{
        this.loading = false;
      })
    },
    handleChange(val){
      console.log('val',val)
      // const leafNodes = this.$refs.myCascader.getCheckedNodes(true)
      // this.leafNodeValues = leafNodes.map(node => node.value)
      //
      // console.log('所有选中值:', value)
      // console.log('仅叶子节点值:', this.leafNodeValues)
    },
    handleModify() {
      this.imageUrl = '';
      this.$nextTick(() => {
        this.$el.querySelector('.el-upload__input').click();
      });
    },
    handleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw);
      // console.log('this.imageUrl',this.imageUrl,res)
      if(res.code !== 10200){
        this.$message.error(res.message);
      }else{
        this.imageUrl = res.data;
      }
    },
    // 顶部切换
    changextop(val) {
      this.$nextTick(() => {
        this.$refs.editform.clearValidate();
      })
      localStorage.setItem('infonum',val);//个人信息的切换靠这个显示
      this.xtopnum = val;
      this.resetpage(1)
      if(val == 2){//我的论坛
        this.getlunlist();
      }else if(val == 3){
        this.getmsglist()
      }
    },
    // 我发布的列表
    getlunlist(){
      let data= {};
      data.pageNumber=this.pageObjlone.currentPage;
      data.pageSize=this.pageObjlone.pageSize;
      data.type=1;
      this.$http({
        url: "post/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObjlone.total = res.data.total;
        this.datalist = res.data.records;
      });
    },
    // 消息-邀请我的
    getmsglist(){
      // 检查是否有用户信息，没有则不调用
      let userinfo = JSON.parse(localStorage.getItem('muiuserinfo') || '{}')?.userInfo || null
      if (!userinfo) {
        return;
      }
      let data=JSON.parse(JSON.stringify(this.xform));
      data.pageNumber=this.pageObj.currentPage;
      data.pageSize=this.pageObj.pageSize;
      data.time=data.time&& data.time.length == 2?(this.$timeDay(data.time[0],1)+'~'+this.$timeDay(data.time[1],1)):'';
      this.$http({
        url: "msg/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObj.total = res.data.total;
        this.datayaolist = res.data.records;
      });
    },
    // 消息-回复我的
    gethuimy(){
      let data= {};
      data.pageNumber=this.pageObjh.currentPage;
      data.pageSize=this.pageObjh.pageSize;
      data.type=1;
      this.$http({
        url: "comment/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObjh.total = res.data.total;
        this.datahuimylist = res.data.records;
      });
    },
    // 我回复的
    getmyhuilist(){
      let data= {};
      data.pageNumber=this.pageObjltwo.currentPage;
      data.pageSize=this.pageObjltwo.pageSize;
      data.type=0;
      this.$http({
        url: "comment/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObjltwo.total = res.data.total;
        this.datalisttwo = res.data.records;
      });
    },
    pageChange(page) {
      this.pageObj.currentPage = page;
      this.getmsglist();
    },
    pageChangeh(page) {
      this.pageObjh.currentPage = page;
      this.gethuimy();
    },
    pageChangelone(page) {
      this.pageObjlone.currentPage = page;
      this.getlunlist();
    },
    pageChangeltwo(page) {
      this.pageObjltwo.currentPage = page;
      this.getmyhuilist();
    },
    changenum(num) {
      this.mynum = num;
      this.resetpage();
      if(this.mynum==0){
        this.getmsglist();
      }else{
        this.gethuimy();
      }
    },
    changelunnum(num) {
      this.lunnum = num;
      this.resetpage();
      if(this.lunnum==0){
        this.getlunlist();
      }else{
        this.getmyhuilist();
      }
    },
    closerecover() {
      this.recoverlook = false;
    },
    recover() {
      this.recoverlook = true;
    },
    getcode() {
      if (this.isSend) {
        return
      }
      this.isSend = true;//定时开始之前一定要加上  不然会鬼畜 验证码
      // 鬼畜是因为点击的时候又重复出发定时器了  所有要加上this.isSend = true;
      this.clock = setInterval(() => {
        this.seconds--;
        this.msg = '重新获取(' + this.seconds + 's)';
        if (this.seconds === 0) {
          clearInterval(this.clock);
          this.seconds = 60;
          this.isSend = false;
          this.msg = '重新获取';
        }
      }, 1000);
    },
    getcodet() {
      if (this.isSendt) {
        return
      }
      this.isSendt = true;//定时开始之前一定要加上  不然会鬼畜 验证码
      // 鬼畜是因为点击的时候又重复出发定时器了  所有要加上this.isSend = true;
      this.clockt = setInterval(() => {
        this.secondst--;
        this.msgt = '重新获取(' + this.secondst + 's)';
        if (this.secondst === 0) {
          clearInterval(this.clockt);
          this.secondst = 60;
          this.isSendt = false;
          this.msgt = '重新获取';
        }
      }, 1000);
    },
    // 注册
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
            let data = JSON.parse(JSON.stringify(this.loginform));
          this.loading = true;
          let url="";
          if(this.locolnum == 0){
            url="user/login"
            data.pwd = this.$cryptoadd.encryptData(data.password);//加密
          }else{
            url="user/reg"
          }
          this.$http({
            url:url,
            method:'post',
            data:this.locolnum == 0?this.$form(data):data
          }).then((res)=>{
            this.loading = false;
            // 登录/注册成功后处理
            if(res.data && res.data.token) {
                localStorage.setItem('muiuserinfo', JSON.stringify({
                    token: res.data.token,
                    userInfo: res.data.userInfo
                }));
            } else {
                localStorage.setItem('muiuserinfo', JSON.stringify({userInfo: res.data}));
            }
            this.$emit('changecolor', 0);
            this.$router.push({path:'/'})
          }).catch(err=>{
            this.loading = false;
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    subinfoform(formName) {
      let data={
        photo:this.imageUrl,
        name:this.infoform.name
      }
      this.$http({
        url: "user/edit",
        method: "POST",
        data: data
      }).then(res => {
        this.$message({
          message: '保存成功！',
          type: 'success'
        });
        this.getuserinfo()
      });
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     // alert('submit!');
      //   } else {
      //     console.log('error submit!!');
      //     return false;
      //   }
      // });
    },
    getuserinfo(){
      let data={}
      this.$http({
        url: "user/info",
        method: "POST",
        data: data
      }).then(res => {
        this.userinfo = res.data;
        // 更新localStorage，保持token不变，只更新userInfo
        let userDataStr = localStorage.getItem('muiuserinfo');
        if(userDataStr) {
            try {
                let userData = JSON.parse(userDataStr);
                userData.userInfo = res.data;
                localStorage.setItem('muiuserinfo', JSON.stringify(userData));
            } catch(e) {
                localStorage.setItem('muiuserinfo', JSON.stringify({userInfo: res.data}));
            }
        } else {
            localStorage.setItem('muiuserinfo', JSON.stringify({userInfo: res.data}));
        }
      });
    },
    subeditform(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data={
            // oldpwd:this.$cryptoadd.encryptData(this.editform.passwordy),
            // pwd:this.$cryptoadd.encryptData(this.editform.passthr),
            oldpwd:this.editform.passwordy,
            pwd:this.editform.passthr,
          }
          this.$http({
            url: "user/editpwd",
            method: "POST",
            data: this.$form(data)
          }).then(res => {
            this.$message({
              message: '密码修改成功！',
              type: 'success'
            });
            this.editform = Object.assign(this.editform, this.$options.data().editform)
          });

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitFormcover(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          let data = JSON.parse(JSON.stringify(this.recoverform));
          // this.loading = true;
          this.$http({
            url:'user/findpwd',
            method:'post',
            data:this.$form(data)
          }).then((res)=>{
            this.$message({
              message: '密码找回成功，请重新登录！',
              type: 'success'
            });
            this.recoverlook = false;
            this.loading = false;
          }).catch(err=>{
            this.loading = false;
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    changelonum(num) {
      this.locolnum = num;
      this.loginform = Object.assign(this.loginform, this.$options.data().loginform)
      this.$nextTick(() => {
        this.$refs.loginform.clearValidate();
      })


    },
    getIpAddress() { //获取ip, 位置
      let year = new Date().getFullYear();
      fetch(`https://${year}.ip138.com/`).then(x => x.text()).then(h => {
        let domParser = new DOMParser();
        let doc = domParser.parseFromString(h, "text/html");
        let text = doc?.querySelector('p')?.innerText?.trim();
        console.log('text', text)//您的iP地址是：[xxx.xx.xxx.xxx ] 来自：中国上海xx xx
        try {
          let ip = text.substring(text.indexOf("[") + 1, text.indexOf("]")).trim();
          this.ipAddress.ip = ip;
          let other = text.substring(text.indexOf("来自：") + 3).trim();
          let arr = other.split(" ");
          this.ipAddress.location = arr[0];
          this.ipAddress.type = arr[1];
        } catch (e) {
          console.error(e)
        }
      })
    },

    subsear() {
      // if (!this.userinfo) {
      //   this.$message({
      //     message: '请先进行登录再进行操作！',
      //     type: 'warning',
      //     duration: 2000
      //   });
      //   return false;
      // }

      let timein = [];
      if(this.sform.time.length == 2){
        timein=[this.$timeDay(this.sform.time[0],1),this.$timeDay(this.sform.time[1],1),];
      }
      // if(!this.sform.categoryId){
      //   this.$message({
      //     message: '文件类型不能为空！',
      //     type: 'error'
      //   });
      //   return false;
      // }
      this.$router.push({
        path: 'knowledgesearch',
        query: {
          parentid: this.sform.categoryId[0],//父级id
          id: this.sform.categoryId[1],//分类id
          time: JSON.stringify(timein),
          input: this.sform.input,
          user: this.sform.user,
        }
      })
      localStorage.setItem('search','1')
    },
    resetsear() {
      this.sform = Object.assign(this.sform, this.$options.data().sform)
      console.log(this.sform)
    },
    // ttt
    topage(val) {
      // if (!this.userinfo) {
      //   this.$message({
      //     message: '请先进行登录再进行操作！',
      //     type: 'warning',
      //     duration: 2000
      //   });
      //   return false;
      // }
      if(this.userinfo && !this.userinfo.roleId) {
        this.$message({
          message: '暂无角色，请联系管理员！',
          type: 'warning',
          duration: 2000
        });
        return false;
      }
      console.log('this.neilist',this.neilist,val)
      let data = this.neilist.find(item=>item.id == val.id)
      console.log('球data',data)
      if(val.name != '争鸣论坛' && val.name != '智能助理'){
        if(!data){
          this.$message({
            message: '您暂无此权限！',
            type: 'warning',
            duration: 2000
          });
          return false;
        }else if(val.id == '1988863618597699585'){//课程案例特殊
          this.$router.push({
            path: 'knowledgecourse',
            query: {
              parentid: data.id,
            }
          })
        }else{
          this.$router.push({
            path: 'knowledge',
            query: {
              parentid: data.id,
              artiid: null
            }
          })
        }
      }else if(val.name == '智能助理'){
        if (!this.userinfo) {
          this.$message({
            message: '请先进行登录再进行操作！',
            type: 'warning',
            duration: 2000
          });
          return false;
        }
        this.$router.push({
          path: '/AI'
        })
        // window.open('https://www.baidu.com/', '_blank');
      }else if(val.name == '争鸣论坛'){
        if (!this.userinfo) {
          this.$message({
            message: '请先进行登录再进行操作！',
            type: 'warning',
            duration: 2000
          });
          return false;
        }
        this.$router.push({
          path: '/forum'
        })
      }

    },
    handleClickOutside(e) {
      this.$nextTick(() => {
        // 获取日期选择器元素
        const datePicker = this.$refs.datePicker.$el;
        // 判断点击是否在日期选择器外部
        if (datePicker && !datePicker.contains(e.target)) {
          // 关闭日期选择器
          this.$refs.datePicker.handleClose();
        }
      })

    },
    onSubmit() {

    },
    to(val) {
      // this.color = val
      // this.Show = false
      // this.show = true
      // if (val == 'companyIntro') {
      //     this.companyShow = true;
      //     this.leaderShow = false;
      //     this.CultureShow = false;
      //     this.title = '公司简介'
      // } else if (val == 'leaderMessage') {
      //     this.companyShow = false;
      //     this.leaderShow = true;
      //     this.CultureShow = false;
      //     this.title = '领导寄语'
      // } else if (val == 'corporateCulture') {
      //     this.companyShow = false;
      //     this.leaderShow = false;
      //     this.CultureShow = true;
      //     this.title = '企业文化'
      // } else {
      //     this.title = '荣誉资质'
      //     this.goHonor(val)
      // }
    },
    getData() {
      // this.$http({
      //   url: 'aboutUs/queryAboutUsInfo',
      //   method: 'post'
      // }).then((res) => {
      //   this.aboutall = res.data
      //   this.aboutUs=res.data.aboutUs
      //   this.banner = res.data.banner
      // })
    },
    goHonor(val) {
      this.title = '荣誉资质'
      this.color = val
      this.Show = true
      this.show = false
      this.$http({
        url: 'aboutUs/queryHonors?page=1&limit=10',
        method: "post"
      }).then((res) => {
        this.honorList = res.data
      })
    },
    initCircles(count) {
      console.log(count)
      this.circles = [];
      // 简单的均匀角度分布
      for (let i = 0; i < count; i++) {
        const angle = (i / count) * 360;
        const radian = angle * Math.PI / 180;

        // 计算位置
        const posX = this.baseRadiusX * Math.cos(radian);
        const posY = this.baseRadiusY * Math.sin(radian);

        // 计算大小和透明度
        const { size, opacity } = this.calculatePropertiesByY(posY);
        const normalizedY = (posY + this.baseRadiusY) / (2 * this.baseRadiusY);
        const zIndex = Math.round(5 + normalizedY * 5);
        let name=this.neilist2[i].name;
        let id=this.neilist2[i].id;
        let url=this.imgurl[i].url;
        // console.log('name',name,id)
        this.circles.push({
          name:name,
          id:id,
          url:url,
          text: this.texts[i % this.texts.length],
          currentSize: size,
          currentOpacity: opacity,
          posX: posX,
          posY: posY,
          angle: angle,
          color: this.colors[i % this.colors.length],
          zIndex: zIndex,
          speed: 360 / this.rotationSpeed,
          initialAngle: angle,
        });
      }
      console.log('this.circles',this.circles)
    },

    // 根据Y坐标计算大小和透明度 yyy
    calculatePropertiesByY(y) {
      const minSize = this.minSize;
      const maxSize = this.maxSize;
      const minOpacity = 0.4;
      const maxOpacity = 1.0;

      const normalizedY = (y + this.baseRadiusY) / (2 * this.baseRadiusY);
      const sizeFactor = Math.pow(normalizedY, 0.7);
      const opacityFactor = Math.pow(normalizedY, 0.8);

      return {
        size: minSize + (maxSize - minSize) * sizeFactor,
        opacity: minOpacity + (maxOpacity - minOpacity) * opacityFactor
      };
    },

    // 动画循环
    animate() {
      if (!this.animationRunning) return;

      const now = Date.now();
      if (!this.lastUpdateTime) {
        this.lastUpdateTime = now;
      }
      const deltaTime = (now - this.lastUpdateTime) / 1000;
      this.lastUpdateTime = now;

      this.circles.forEach(circle => {
        // 更新角度
        circle.angle += circle.speed * deltaTime * this.direction;
        if (circle.angle >= 360) circle.angle -= 360;
        if (circle.angle < 0) circle.angle += 360;

        // 计算新位置
        const radian = circle.angle * Math.PI / 180;
        circle.posX = this.baseRadiusX * Math.cos(radian);
        circle.posY = this.baseRadiusY * Math.sin(radian);

        // 根据Y位置实时计算大小和透明度
        const { size, opacity } = this.calculatePropertiesByY(circle.posY);
        circle.currentSize = size;
        circle.currentOpacity = opacity;

        // 更新z-index
        const normalizedY = (circle.posY + this.baseRadiusY) / (2 * this.baseRadiusY);
        circle.zIndex = Math.round(5 + normalizedY * 5);
      });

      this.animationFrameId = requestAnimationFrame(this.animate);
    },

    startAnimation() {
      this.animationRunning = true;
      this.lastUpdateTime = null;
      this.animate();
    },

    stopAnimation() {
      this.animationRunning = false;
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
    },

    addCircle() {
      if (this.circles.length >= 12) {
        alert('最多只能添加12个圆形');
        return;
      }

      this.initCircles(this.circles.length + 1);
    },

    removeCircle() {
      if (this.circles.length > 0) {
        this.initCircles(this.circles.length - 1);
      }
    },

    toggleAnimation() {
      if (this.animationRunning) {
        this.stopAnimation();
      } else {
        this.startAnimation();
      }
    },

    resetAnimation() {
      this.stopAnimation();
      this.initCircles(8);
      this.startAnimation();
      this.direction = 1;
    },

    reverseDirection() {
      this.direction = -this.direction;
    },

    selectCircle(circle) {
      // alert(`选中了圆形: ${circle.text}\n当前大小: ${Math.round(circle.currentSize)}px\n当前透明度: ${Math.round(circle.currentOpacity * 100)}%\n位置角度: ${Math.round(circle.angle)}度`);
    },
  },
}
</script>
<!--33-->
<style src="@/styles/roatestyle.css" scoped></style>
<!--333-->
<style lang="scss" scoped>
.paindexouter{
  overflow: hidden !important;
}
.z999{
  z-index: 999;
}
@media screen and (max-width: 1440px)  {
  .paindexouter{
    //background-image: url("../assets/img/sunshine.webp") !important;
  }
  .qiuout{
    bottom: 13%;
  }
  .wmiddle .searbtn1{
    width: 50PX;
    height: 50PX;
    line-height: 50PX;
  }
  .wmiddle .searbtn2{
    width: 50PX;
    height: 50PX;
    line-height: 50PX;
  }
  /deep/ {
    .wmiddle .sformin .el-form-item__label{
      line-height: 50px !important;
    }
    .wnew200 .el-input__inner {
      width: 122px !important;
      height: 50px !important;
    }

    .wnew270 .el-input__inner {
      height: 50px !important;
      width: 250px !important;
    }
    .wmiddle .wnew270 .el-range-separator{
      line-height: 44px !important;
    }
  }

  .bottomd{
    display: none !important;
  }
}
.sinput1{
  width: 1200px;
}
.paindexouter {
  //background-image: url("../assets/1920915.png");
  //background-size: 100% 100%;
  //background-repeat: no-repeat;

  //overflow: hidden;
  background-image: url("../assets/img/homentxt.png");
  background-size: cover;
  background-position: bottom center; /* 关键：底部对齐 */
  background-repeat: no-repeat;

}
.wmiddle{
  width:100vw;
  margin:auto;
  height:100vh;
  box-sizing: border-box;
  padding-top: 80px;
}
</style>
<style lang="scss">
.yuannew{
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background:cyan;
}
.touwai {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  margin-bottom: 8px;
  position: relative;
  overflow: hidden;

  .xiut {
    cursor: pointer;
    width: 100%;
    height: 33px;
    position: absolute;
    left: 0;
    bottom: 0;
    text-align: center;
    line-height: 33px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99;
    color: white;
    font-size: 15px;
  }

  .el-upload {
    img {
      width: 88px;
      height: 88px;
      border-radius: 50%;
    }
  }
}

.toptl1 {
  font-size: 24px;
  color: #fff;
  margin-bottom: 20px;
}

.avatar-uploader .el-upload {
  //border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  line-height: 88px !important;
  text-align: center;
  background: #0E3E6C;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.noborder {
  border: none !important;
  padding: 0 !important;
  color: white !important;
  text-decoration: none;
  background-color: transparent !important;
  text-align: left !important;
  font-weight: bold;
}

.noborder:hover {
  background: none;
  color: #0090FF !important;
}

.infored {
  width: 12px;
  height: 12px;
  background: red;
  border-radius: 50%;
  margin-left: 11px;
}

.pert {
  width: 150px;
  height: 50px;
  background: #0E3E6C;
  border: 1px solid #0090FF;
  border-radius: 16px 16px 0 0;
  font-size: 22px;
  margin-right: 10px;
  color: #fff;
  cursor: pointer;
}

.xtophot {
  background: #0090FF;
}

.mlogo5 {
  width: 80px;
  height: 80px;
  margin-right: 30px;
}

.pertmid {
  width: 100%;
  height: 650px;
  background: rgba(14, 62, 108, 0.8);
  border-radius: 0 16px 16px 16px;

  .permidleft {
    width: 20%;
    height: 100%;
    overflow-y: auto;
    background: rgba(14, 62, 108, 0.9);
    border-radius: 0 16px 16px 16px;
    box-sizing: border-box;
    padding: 20px 0;

    .perhot {
      background: linear-gradient(90deg, #075393 0%, rgba(14, 62, 108, 0.9) 100%);
      position: relative;
      transition: 0.8s;

      &::before {
        content: "";
        width: 6px;
        height: 26px;
        background: #0090FF;
        position: absolute;
        top: 17px;
        left: 0;
      }
    }

    .perw1 {
      width: 100%;
      height: 60px;
      font-size: 18px;
      color: white;
      cursor: pointer;

      .redm {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: red;
        margin-left: 15px;
      }
      .redmtran {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-left: 15px;
      }
    }
  }

  .permidright {
    width: 80%;
    overflow-y: auto;
    height: 100%;
    box-sizing: border-box;
    padding: 0 40px 20px 40px;
    background: rgba(6, 15, 30, 0.6);
  }

  .permidright2 {
    width: 80%;
    overflow-y: auto;
    height: 100%;
    box-sizing: border-box;
    background: rgba(6, 15, 30, 0.6);
  }

  .permid2 {
    height: 75%;
    overflow-y: auto;
  }

  .permid22 {
    height: 88%;
    overflow-y: auto;
  }

  .lunlist1 {
    box-sizing: border-box;
    padding: 20px 40px;
    border-bottom: 1px solid #0C3761;
  }

  .permid21 {
    height: 90%;
    overflow-y: auto;
    box-sizing: border-box;
    padding-top: 20px;
  }

  .huits1 {
    font-size: 18px;
    color: white;
  }

  .huits3 {
    font-size: 16px;
    color: #B2B4CB;
  }

  .huits4 {
    width: 21px;
    height: 19px;
    margin-right: 5px;
  }

  .huits6 {
    width: 21px;
    height: 19px;
    margin-left: 5px;
  }

  .huits5 {
    font-size: 16px;
    color: white;
  }
  .huitsnew5{
    max-width: 90%;
    min-width: max-content;
  }
  .huits2 {
    font-size: 18px;
    color: #A0B8E2;
    margin-left: 10px;
    margin-right: 10px;
  }

  .perms3 {
    font-size: 18px;
  }

  .perms1 {
    color: white;
  }

  .perms2 {
    color: #A0B8E2;
    margin-left: 6px;
    margin-right: 6px;
  }

  .perms5 {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: red;
  }

  .perms9 {
    font-size: 20px !important;
    font-weight: bold;
    color: white;
    margin-bottom: 15px;
    //cursor: none !important;
  }

  .perms9:hover {
    background: none;
    color: white !important;
  }

  .permb1 {
    font-size: 15px;
    color: #B2B4CB;
  }

  .permb2 {
    //width: 15px;
    //height: 13px;
    margin-right: 3px;
  }

  .mlr15 {
    margin-left: 15px;
    margin-right: 15px;
  }

  .mlr10 {
    margin-left: 10px;
    margin-right: 10px;
  }

  .perms6 {
    font-size: 16px;
    color: #B2B4CB;
  }

  .perms7 {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    border-radius: 16px;
    background: rgba(14, 62, 108, 0.8);
    margin-top: 15px;
    margin-bottom: 15px;
  }
}

.tanpass1 {
  .el-dialog {
    border-radius: 16px;
  }

  .el-dialog__body {
    padding: 0 0 20px 0;
    background: #0B3E73;
    border-radius: 0 0 15px 15px;
  }

  .el-dialog__header {
    padding: 20px 0 0 0;
    background: #0B3E73;
    border-radius: 15px 15px 0 0;
    text-align: center;

    .el-dialog__title {
      color: white !important;
      font-size: 18px;
      font-weight: bold;
    }
  }

}

.yaninput {
  position: relative;

  .cgetm {
    position: absolute;
    right: 10px;
    top: 18px;
    font-size: 16px;
    line-height: 16px;
    color: #0090FF;
    cursor: pointer;
  }

  .el-input__inner {
    box-sizing: border-box;
    padding-right: 90px;
  }
}

.el-input__inner:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #060F1E inset !important; /* 背景色 */
  -webkit-text-fill-color: #fff !important; /* 文字颜色 */
}

/* 仅针对密码输入框 */
.el-input__inner[type="password"]:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #060F1E inset !important;
}

.fogetm {
  width: 100%;
  text-align: center;
  color: white;
  margin-top: 10px;
  font-size: 16px;

  span {
    cursor: pointer;
  }

  span:nth-child(2) {
    text-decoration: underline;
  }
}

.loginformnew {
  width: 45% !important;
  margin-left: 22% !important;
}

.loginformnew .el-input .el-input__inner {
  background: rgba(6, 15, 30, 0.5) !important;
  border: 1px solid #092948 !important;
}

.loginform {
  width: 60%;
  margin-left: 15%;
  box-sizing: border-box;
  padding-top: 30px;

  .cloginb1 {
    cursor: pointer;
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #0090FF;
    border-radius: 16px;
    text-align: center;
    font-size: 18px;
    color: white;
  }

  ///deep/ {
  .el-form-item__label {
    height: 55px;
    line-height: 55px;
    color: #fff;
    font-size: 16px;
  }

  .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: '';
    color: #F56C6C;
  }

  .el-input.is-active .el-input__inner, .el-input__inner:focus {
    border-color: #0090FF !important;
  }

  .el-input__inner::placeholder {
    color: #909399;
  }

  .el-input .el-input__inner {
    background: #060F1E;
    border: 1px solid #060F1E;
    //border-color: #060F1E;
    height: 55px;
    line-height: 55px;
    color: white;
    border-radius: 16px;
  }

  //}
}

.login1 {
  margin: 0 auto;
  width: 860px;
  height: 680px;
  margin-top: 40px;
  box-sizing: border-box;
  padding: 40px 40px 0 40px;
  border-radius: 16px;
  border: 1px solid #1D5FB2;
  background: rgba(6, 15, 30, 0.5);
  box-shadow: 2px 6px 20px 0px rgba(14, 62, 108, 0.2);

  .logind1 {
    cursor: pointer;
    width: 100px;
    text-align: center;
    //background: pink;
    font-size: 24px;
    color: white;
    position: relative;
    //font-weight: bold;
  }

  .logindhot::after {
    content: "";
    width: 20px;
    height: 5px;
    background: #0090FF;
    position: absolute;
    top: 0px;
    right: 0px;
    left: 0px;
    bottom: -57px;
    margin: auto;
  }
}

.qiuno {
  background-image: url(../assets/qiu.png);
  background-repeat: no-repeat;
  cursor: pointer;
}

.qiux {
  background-image: url(../assets/qiuxuan.png);
  background-repeat: no-repeat;
  cursor: pointer;
  color: #0863B1;
}

.cqimg {
  width: 2rem;
  height: 2rem;
}

.cq-t1 {
  font-size: 1.7rem;
  margin-bottom: 1rem;
  font-weight: bold;
}

.cq-t2 {
  font-size: 1rem;
  color: white;
}

.cq-t3 {
  font-size: 1rem;
}

.main-out {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
}


.qiuout {
  //display: none;//放开
  width: 100%;
  height: 500px;
  //background: pink;
  //position: relative;
  position: absolute !important;
  bottom: 8%;
  left: 0%;
  .qiuone {
    cursor: pointer;
    width: 180px;
    height: 180px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 50%;
    background-image: url("../assets/qiu.png");
    transition: 0.5s;

    .qium1 {
      height: 40px;
    }

    .qium2 {
      font-size: 17px;
      color: white;
    }
  }

  //.qiucold{
  //  background-image: url("../assets/qiu.png");
  //}
  .qiuhot {
    width: 150px !important;
    height: 150px !important;
    background-image: url("../assets/da.png") !important;
    transition: 0.5s;
  }

  .q1 {
    position: absolute;
    top: 220px;
    left: 30px;
  }

  .q2 {
    position: absolute;
    top: 66px;
    left: 170px;
  }

  .q3 {
    position: absolute;
    top: 276px;
    left: 190px;
  }

  .q4 {
    position: absolute;
    top: 146px;
    left: 320px;
  }

  .q5 {
    position: absolute;
    top: 0px;
    left: 420px;
  }

  .q6 {
    position: absolute;
    top: 160px;
    left: 500px;
  }

  .q7 {
    position: absolute;
    top: 320px;
    left: 440px;
  }

  .q8 {
    position: absolute;
    top: 70px;
    left: 660px;
  }

  .q9 {
    position: absolute;
    top: 270px;
    left: 720px;
  }

  .q10 {
    position: absolute;
    top: 90px;
    left: 860px;
  }

  .q11 {
    position: absolute;
    top: 280px;
    left: 940px;
  }
}

.wmiddle {
  .w200 .el-input__inner {
    width: 222px;
  }

  .w270 .el-input__inner {
    width: 350px;
  }

  .sformin {
    margin-top: 20px;
  }

  .sformin .el-input__inner {
    height: 60px;
    background: rgba(14, 62, 108, 0.5);
    border-radius: 16px;
    font-size: 18px;
    border: none;
    color: white;
  }

  .sformin2 .el-input__inner {
    height: 60px;
    background: #060F1E;
    border-radius: 16px;
    font-size: 18px;
    border: none;
    color: white;
  }

  .sformin .el-form-item__label {
    height: 60px;
    line-height: 60px;
    color: white;
    font-size: 18px;
  }

  .sformin .el-range-input {
    color: white;
    font-size: 18px;
    background: rgba(14, 62, 108, 0);
  }

  .sformin .el-range-separator {
    line-height: 54px;
    color: white;
  }

  .sinput1 {
    margin-top: 40px;
  }

  .sinput1 .el-input__inner {
    width: 100%;
    height: 60px;
    background: #0E3E6C;
    border: 1px solid #0090FF;
    border-radius: 16px;
    font-size: 18px;
    color: white;
  }

  .searbtn1 {
    width: 60PX;
    height: 60PX;
    text-align: center;
    line-height: 60PX;
    display: inline-block;
    background: #0090FF;
    border-radius: 16px;
    font-size: 24px;
    color: white;
    margin-right: 10px;
  }

  .searbtn2 {
    width: 60PX;
    height: 60PX;
    text-align: center;
    line-height: 60PX;
    display: inline-block;
    background: #DCDFE6;
    border-radius: 16px;
  }

}

.paindexouter {
  overflow: hidden;
  position: absolute;
  width: 100%;
  height:100vh;
  overflow-y: scroll;
  top: 0;
  z-index: -1;
}

.page-index {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100vh;
}

.videoone {
  width: 100%;
  height: 100%;
  //object-fit: cover; /* 保持视频比例并覆盖整个容器 */
}

.videotwo {
  width: 100%;
  //height:500px;
  object-fit: cover; /* 保持视频比例并覆盖整个容器 */
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 9;
}
</style>
<!--旋转样式-->
<style lang="scss">


.container {
  text-align: center;
  width: 100%;
  max-width: 1000px;
}

h1 {
  color: white;
  margin-bottom: 30px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  font-weight: 300;
  letter-spacing: 2px;
}

.animation-container {
  position: relative;
  width: 800px;
  height: 600px;
  margin: 0 auto;
}

.center-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 40px rgba(255, 255, 255, 0.5);
  z-index: 10;
  font-weight: bold;
  color: #1a2a6c;
  font-size: 16px;
}

.orbiting-circle {
  position: absolute;
  border-radius: 50%;
  background-image: url(../assets/qiu.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  cursor: pointer;
  //display: flex;
  //justify-content: center;
  //align-items: center;
  font-weight: bold;
  color: white;
  //box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  left: 50%;
  top: 50%;
  transform-origin: center;
  transform: translate(-50%, -50%) translateX(var(--posX)) translateY(var(--posY));
  transition: width 0.1s ease, height 0.1s ease, opacity 0.1s ease;
  font-size: 18px;
}

.orbiting-circle:hover {
  z-index: 20;
  opacity: 1 !important;
  background-image: url(../assets/qiuxuan.png) !important;

}

.controls {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
}

button {
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 30px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
}

button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

.info-panel {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 20px;
  margin-top: 30px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.info-panel h3 {
  color: white;
  margin-bottom: 15px;
  font-weight: 400;
}

.info-panel p {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  font-size: 14px;
}

.stats {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 15px;
  flex-wrap: wrap;
}

.stat-item {
  background: rgba(255, 255, 255, 0.1);
  padding: 10px 15px;
  border-radius: 10px;
  color: white;
  font-size: 14px;
}

.gradient-indicator {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.2);
  padding: 10px;
  border-radius: 10px;
  color: white;
  font-size: 12px;
  backdrop-filter: blur(5px);
  text-align: left;
}
</style>